// extracted by mini-css-extract-plugin
var _1 = "PageHeaderNotifications-modulecontainer__qIfQ6";
export { _1 as "container" }
